import styled from '@emotion/styled'
import React from 'react'

const Wrapper = styled.div`
  padding: 0;
`

/**
 * SVGアイコンコンポーネント
 * マニュアルダウンロードアイコン
 */
const ManualDownloadSvg = (): JSX.Element => (
  <Wrapper>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40.775">
      <path
        d="M.715,0H42.938a.714.714,0,0,1,.714.714V27.727a.715.715,0,0,1-.715.715H.715A.715.715,0,0,1,0,27.727V.715A.715.715,0,0,1,.715,0Z"
        transform="translate(1.43 2.486)"
        fill="#fff"
      />
      <path
        d="M44.366,32.358H2.144A2.147,2.147,0,0,1,0,30.214V3.2A2.147,2.147,0,0,1,2.144,1.057H44.366A2.147,2.147,0,0,1,46.511,3.2V30.214a2.147,2.147,0,0,1-2.145,2.144M2.144,2.486a.716.716,0,0,0-.715.715V30.214a.715.715,0,0,0,.715.714H44.366a.715.715,0,0,0,.715-.714V3.2a.716.716,0,0,0-.715-.715Z"
        fill="#313a38"
      />
      <path
        d="M38.959,18.454c.065-.007.131-.011.2-.012-.065,0-.131.005-.2.012"
        fill="#fff"
      />
      <path d="M44.186,23.31l-.038-.033.038.033" fill="#fff" />
      <path
        d="M39.553,18.469a2.387,2.387,0,0,1,.279.06,2.387,2.387,0,0,0-.279-.06"
        fill="#fff"
      />
      <path d="M35.769,11.45l.045.062-.045-.062" fill="#fff" />
      <path
        d="M38.637,18.508a2.249,2.249,0,0,1,.251-.046,2.249,2.249,0,0,0-.251.046"
        fill="#fff"
      />
      <path
        d="M44.818,23.459a.738.738,0,0,1-.16.02.738.738,0,0,0,.16-.02"
        fill="#fff"
      />
      <path
        d="M41.316,22.647a.738.738,0,0,1-.16.02.738.738,0,0,0,.16-.02"
        fill="#fff"
      />
      <path
        d="M35.89,11.624c.015.023.029.046.042.07-.013-.024-.027-.047-.042-.07"
        fill="#fff"
      />
      <path
        d="M47.532,33.687a.7.7,0,0,1-.021-.171L47.49,23.9l.021,9.619a.7.7,0,0,0,.021.171l.887,3.568Z"
        fill="#fff"
      />
      <path
        d="M41.837,21.781a.88.88,0,0,1,.028-.517.88.88,0,0,0-.028.517.715.715,0,0,1-.265.744.715.715,0,0,0,.265-.744"
        fill="#fff"
      />
      <path
        d="M36.09,12.022c.008.022.018.043.025.065-.007-.022-.017-.043-.025-.065"
        fill="#fff"
      />
      <path d="M36,11.813l.036.072L36,11.813" fill="#fff" />
      <path
        d="M39.212,18.44a2.433,2.433,0,0,1,.284.02,2.433,2.433,0,0,0-.284-.02"
        fill="#fff"
      />
      <path
        d="M40.688,18.986a2.132,2.132,0,0,1,.2.192,2.132,2.132,0,0,0-.2-.192"
        fill="#fff"
      />
      <path
        d="M46.815,21.745a.961.961,0,0,1,.068.074.961.961,0,0,0-.068-.074"
        fill="#fff"
      />
      <path
        d="M41.129,19.483a2.385,2.385,0,0,1,.148.255,2.385,2.385,0,0,0-.148-.255"
        fill="#fff"
      />
      <path
        d="M40.924,19.216a2.336,2.336,0,0,1,.174.22,2.336,2.336,0,0,0-.174-.22"
        fill="#fff"
      />
      <path
        d="M46.92,21.867a.978.978,0,0,1,.057.094.978.978,0,0,0-.057-.094"
        fill="#fff"
      />
      <path
        d="M47,22.007a.916.916,0,0,1,.057.157A.916.916,0,0,0,47,22.007"
        fill="#fff"
      />
      <path
        d="M39.855,18.537a2.182,2.182,0,0,1,.253.093,2.182,2.182,0,0,0-.253-.093"
        fill="#fff"
      />
      <path
        d="M40.447,18.81a2.209,2.209,0,0,1,.23.167,2.209,2.209,0,0,0-.23-.167"
        fill="#fff"
      />
      <path
        d="M40.155,18.65a2.282,2.282,0,0,1,.244.13,2.282,2.282,0,0,0-.244-.13"
        fill="#fff"
      />
      <path
        d="M35.768,27.655a.693.693,0,0,1-.176-.026.693.693,0,0,0,.176.026"
        fill="#fff"
      />
      <path
        d="M34.242,10.565c.02,0,.041,0,.061.008-.02,0-.041-.005-.061-.008"
        fill="#fff"
      />
      <path
        d="M33.072,13.072l3.406,13.7a.7.7,0,0,1,.02.135.7.7,0,0,0-.02-.135Z"
        fill="#fff"
      />
      <path
        d="M33.239,22.243c.047,0,.093.014.14.022-.047-.008-.093-.017-.14-.022"
        fill="#fff"
      />
      <path
        d="M37.814,21.835a.738.738,0,0,1-.16.02.738.738,0,0,0,.16-.02"
        fill="#fff"
      />
      <path d="M37.182,21.686l-.036-.033.036.033" fill="#fff" />
      <path
        d="M33,22.23c.046,0,.091,0,.136.007-.045,0-.09-.007-.136-.007"
        fill="#fff"
      />
      <path d="M34.507,10.615l.034.01-.034-.01" fill="#fff" />
      <path
        d="M32.765,22.24c.034,0,.067,0,.1,0-.034,0-.067,0-.1,0"
        fill="#fff"
      />
      <path
        d="M32.37,11.148a2.339,2.339,0,0,1,.36-.271,2.339,2.339,0,0,0-.36.271"
        fill="#fff"
      />
      <path
        d="M33.718,12h0a.885.885,0,0,0-.545.4.885.885,0,0,1,.545-.4"
        fill="#fff"
      />
      <path
        d="M33.7,22.343a2.194,2.194,0,0,1,.209.08,2.194,2.194,0,0,0-.209-.08"
        fill="#fff"
      />
      <path
        d="M33.715,10.555c.059-.006.118-.01.177-.011-.059,0-.118.005-.177.011"
        fill="#fff"
      />
      <path
        d="M33.474,22.281c.05.011.1.025.148.039-.049-.014-.1-.028-.148-.039"
        fill="#fff"
      />
      <path
        d="M33.1,12.554a.88.88,0,0,0-.028.517.88.88,0,0,1,.028-.517"
        fill="#fff"
      />
      <path
        d="M34.014,10.545c.026,0,.052,0,.078,0-.026,0-.052,0-.078,0"
        fill="#fff"
      />
      <path
        d="M35.635,11.289c.013.014.024.028.036.042-.012-.014-.023-.028-.036-.042"
        fill="#fff"
      />
      <path
        d="M35.455,11.116c.01.009.022.017.032.027-.01-.01-.022-.018-.032-.027"
        fill="#fff"
      />
      <path
        d="M35.229,27.387a.73.73,0,0,1-.1-.16L33.8,24.191l1.325,3.036a.73.73,0,0,0,.1.16"
        fill="#fff"
      />
      <path
        d="M35.267,10.969c.02.014.04.027.059.042-.019-.015-.039-.028-.059-.042"
        fill="#fff"
      />
      <path d="M32.3,22.336l.08-.021-.08.021" fill="#fff" />
      <path
        d="M31.313,22.95a2.292,2.292,0,0,1,.468-.376,2.292,2.292,0,0,0-.468.376"
        fill="#fff"
      />
      <path
        d="M30.928,23.5a2.279,2.279,0,0,1,.186-.3,2.279,2.279,0,0,0-.186.3"
        fill="#fff"
      />
      <path d="M34.706,10.677l.066.026-.066-.026" fill="#fff" />
      <path d="M40.684,22.5l-.036-.033.036.033" fill="#fff" />
      <path d="M34.9,10.756l.071.035-.071-.035" fill="#fff" />
      <path
        d="M31.757,12.065a2.329,2.329,0,0,1,.456-.758,2.329,2.329,0,0,0-.456.758"
        fill="#fff"
      />
      <path
        d="M35.39,27.537a.713.713,0,0,1-.134-.118.713.713,0,0,0,.134.118"
        fill="#fff"
      />
      <path d="M32.53,22.276l.1-.015-.1.015" fill="#fff" />
      <path
        d="M40.45,22.126l-.394-1.585A.839.839,0,0,0,40,20.384a.917.917,0,0,1,.057.157Z"
        fill="#fff"
      />
      <path d="M35.086,10.853l.068.04-.068-.04" fill="#fff" />
      <path
        d="M38.982,19.9h0a.874.874,0,0,0-.487.325.88.88,0,0,1,.487-.325"
        fill="#fff"
      />
      <path
        d="M43.949,19.622a2.356,2.356,0,0,1,.23.166,2.356,2.356,0,0,0-.23-.166"
        fill="#fff"
      />
      <path d="M41.029,22.659l.027,0-.027,0" fill="#fff" />
      <path
        d="M33.621,23.924a1.078,1.078,0,0,1,.077.088,1.078,1.078,0,0,0-.077-.088"
        fill="#fff"
      />
      <path
        d="M42.7,20.681l-.016,0a.851.851,0,0,1,.124.007.944.944,0,0,0-.108-.009"
        fill="#fff"
      />
      <path
        d="M33.725,24.05a.839.839,0,0,1,.079.141.839.839,0,0,0-.079-.141"
        fill="#fff"
      />
      <path
        d="M33.469,23.8a.836.836,0,0,1,.121.094.836.836,0,0,0-.121-.094"
        fill="#fff"
      />
      <path
        d="M35.411,27.549a.718.718,0,0,0,.146.068.718.718,0,0,1-.146-.068"
        fill="#fff"
      />
      <path
        d="M35.846,27.651c.014,0,.028,0,.041,0-.013,0-.027,0-.041,0"
        fill="#fff"
      />
      <path
        d="M33.332,23.729a.878.878,0,0,1,.126.064.878.878,0,0,0-.126-.064"
        fill="#fff"
      />
      <path
        d="M36.412,27.283a.708.708,0,0,0,.086-.38.708.708,0,0,1-.086.38"
        fill="#fff"
      />
      <path d="M40.873,22.613l.031.014-.031-.014" fill="#fff" />
      <path
        d="M33.179,23.682a1.058,1.058,0,0,1,.11.031,1.058,1.058,0,0,0-.11-.031"
        fill="#fff"
      />
      <path
        d="M43.186,20.832a.941.941,0,0,1,.081.06.941.941,0,0,0-.081-.06"
        fill="#fff"
      />
      <path
        d="M32.07,22.421l0,0c-.037.016-.071.035-.106.052.035-.017.069-.036.106-.052l0,0"
        fill="#fff"
      />
      <path
        d="M32.99,23.659h0a.859.859,0,0,1,.152.014.815.815,0,0,0-.148-.014"
        fill="#fff"
      />
      <path
        d="M43.034,20.75a.971.971,0,0,1,.1.049.971.971,0,0,0-.1-.049"
        fill="#fff"
      />
      <path
        d="M40.75,22.547a.322.322,0,0,0,.039.025.322.322,0,0,1-.039-.025"
        fill="#fff"
      />
      <path
        d="M42.839,20.693a.893.893,0,0,1,.154.04.893.893,0,0,0-.154-.04"
        fill="#fff"
      />
      <path
        d="M32.811,23.678a.542.542,0,0,1,.058-.006.542.542,0,0,0-.058.006"
        fill="#fff"
      />
      <path
        d="M39.811,20.121a.8.8,0,0,1,.068.074.8.8,0,0,0-.068-.074"
        fill="#fff"
      />
      <path
        d="M37.248,21.735a.425.425,0,0,0,.039.025.425.425,0,0,1-.039-.025"
        fill="#fff"
      />
      <path
        d="M36.994,21.441c.006.013.014.025.02.037-.006-.012-.014-.024-.02-.037"
        fill="#fff"
      />
      <path
        d="M37.06,21.555l.03.038c-.01-.012-.021-.025-.03-.038"
        fill="#fff"
      />
      <path
        d="M39.684,20.02c.028.019.056.039.082.06a.955.955,0,0,0-.082-.06"
        fill="#fff"
      />
      <path
        d="M31.685,13.417a2.3,2.3,0,0,1-.04-.918,2.3,2.3,0,0,0,.04.918l2.241,9.011Z"
        fill="#fff"
      />
      <path d="M37.371,21.8l.031.014-.031-.014" fill="#fff" />
      <path
        d="M39.532,19.938a.906.906,0,0,1,.1.05.906.906,0,0,0-.1-.05"
        fill="#fff"
      />
      <path
        d="M39.2,19.869l-.016,0a.865.865,0,0,1,.125.007.981.981,0,0,0-.109-.009"
        fill="#fff"
      />
      <path
        d="M38.173,21.62a.735.735,0,0,0,.141-.234.735.735,0,0,1-.141.234"
        fill="#fff"
      />
      <path d="M37.527,21.847l.027,0-.027,0" fill="#fff" />
      <path
        d="M34.421,12.122a.941.941,0,0,1,.081.06.941.941,0,0,0-.081-.06"
        fill="#fff"
      />
      <path
        d="M33.932,11.971l-.016,0a.865.865,0,0,1,.125.007.981.981,0,0,0-.109-.009"
        fill="#fff"
      />
      <path
        d="M40.562,22.367c.009.013.02.026.03.038-.01-.012-.021-.025-.03-.038"
        fill="#fff"
      />
      <path
        d="M39.917,20.243a.9.9,0,0,1,.057.094.9.9,0,0,0-.057-.094"
        fill="#fff"
      />
      <path
        d="M34.074,11.983a.893.893,0,0,1,.154.04.893.893,0,0,0-.154-.04"
        fill="#fff"
      />
      <path
        d="M34.268,12.041a.993.993,0,0,1,.1.05.993.993,0,0,0-.1-.05"
        fill="#fff"
      />
      <path
        d="M34.653,12.346a.81.81,0,0,1,.057.094.81.81,0,0,0-.057-.094"
        fill="#fff"
      />
      <path
        d="M34.736,12.486a.934.934,0,0,1,.056.156.934.934,0,0,0-.056-.156"
        fill="#fff"
      />
      <path
        d="M40.5,22.253c.006.013.014.025.02.037-.006-.012-.014-.024-.02-.037"
        fill="#fff"
      />
      <path
        d="M34.548,12.224a.8.8,0,0,1,.068.074.962.962,0,0,0-.068-.074"
        fill="#fff"
      />
      <path
        d="M45.313,22.415a.849.849,0,0,1,.019-.208.849.849,0,0,0-.019.208"
        fill="#fff"
      />
      <path
        d="M45.541,21.785a.879.879,0,0,1,.275-.206.879.879,0,0,0-.275.206"
        fill="#fff"
      />
      <path
        d="M46.2,21.492l-.016,0a.852.852,0,0,1,.124.007.963.963,0,0,0-.108-.009"
        fill="#fff"
      />
      <path
        d="M44.189,19.8a2.132,2.132,0,0,1,.2.192,2.132,2.132,0,0,0-.2-.192"
        fill="#fff"
      />
      <path
        d="M44.426,20.028a2.472,2.472,0,0,1,.174.22,2.472,2.472,0,0,0-.174-.22"
        fill="#fff"
      />
      <path
        d="M44.63,20.3a2.227,2.227,0,0,1,.148.255,2.227,2.227,0,0,0-.148-.255"
        fill="#fff"
      />
      <path
        d="M33.633,10.562a2.14,2.14,0,0,0-.259.048,2.321,2.321,0,0,0-.643.267,2.321,2.321,0,0,1,.643-.267,2.14,2.14,0,0,1,.259-.048"
        fill="#fff"
      />
      <path
        d="M42.139,19.32a2.208,2.208,0,0,1,.251-.046,2.208,2.208,0,0,0-.251.046"
        fill="#fff"
      />
      <path
        d="M46.341,21.5a.893.893,0,0,1,.154.04.893.893,0,0,0-.154-.04"
        fill="#fff"
      />
      <path
        d="M42.713,19.252a2.433,2.433,0,0,1,.284.02,2.433,2.433,0,0,0-.284-.02"
        fill="#fff"
      />
      <path
        d="M46.535,21.562a.906.906,0,0,1,.1.05.906.906,0,0,0-.1-.05"
        fill="#fff"
      />
      <path
        d="M39.338,19.881a.893.893,0,0,1,.154.04.893.893,0,0,0-.154-.04"
        fill="#fff"
      />
      <path
        d="M46.688,21.643a.957.957,0,0,1,.082.06.957.957,0,0,0-.082-.06"
        fill="#fff"
      />
      <path
        d="M42.461,19.265c.065-.007.131-.011.2-.012-.065,0-.131,0-.2.012"
        fill="#fff"
      />
      <path
        d="M43.055,19.281a2.387,2.387,0,0,1,.279.06,2.387,2.387,0,0,0-.279-.06"
        fill="#fff"
      />
      <path
        d="M43.656,19.461a2.19,2.19,0,0,1,.244.13,2.19,2.19,0,0,0-.244-.13"
        fill="#fff"
      />
      <path
        d="M43.356,19.349a2.267,2.267,0,0,1,.254.093,2.267,2.267,0,0,0-.254-.093"
        fill="#fff"
      />
      <path
        d="M45.176,23.244a.735.735,0,0,0,.141-.234.735.735,0,0,1-.141.234"
        fill="#fff"
      />
      <path
        d="M44,23.065c.006.013.014.025.02.037-.006-.012-.014-.024-.02-.037"
        fill="#fff"
      />
      <path
        d="M44.53,23.471a.264.264,0,0,0,.028,0,.264.264,0,0,1-.028,0"
        fill="#fff"
      />
      <path
        d="M43.313,20.933a.8.8,0,0,1,.068.074.961.961,0,0,0-.068-.074"
        fill="#fff"
      />
      <path
        d="M43.419,21.055a.811.811,0,0,1,.057.094.811.811,0,0,0-.057-.094"
        fill="#fff"
      />
      <path
        d="M43.5,21.2a.9.9,0,0,1,.057.158A.9.9,0,0,0,43.5,21.2"
        fill="#fff"
      />
      <path d="M44.374,23.424l.032.014-.032-.014" fill="#fff" />
      <path
        d="M44.251,23.359a.425.425,0,0,0,.039.025.425.425,0,0,1-.039-.025"
        fill="#fff"
      />
      <path
        d="M44.064,23.178l.03.038c-.01-.012-.021-.025-.03-.038"
        fill="#fff"
      />
      <path
        d="M42.791,27.33V2.5C42,2.042,39.968,1.134,36.1,1.134h-.016c-.787,0-1.62.038-2.475.112-5.751.5-8.524,2.3-9.382,2.976V28.9A48.02,48.02,0,0,1,33.41,27.38c2-.174,3.844-.262,5.486-.262a30.771,30.771,0,0,1,3.9.212"
        fill="#fff"
      />
      <path
        d="M12.909,1.256c-.855-.074-1.688-.112-2.475-.112-3.909,0-5.939.9-6.708,1.357V27.34a30.752,30.752,0,0,1,3.894-.212c1.643,0,3.489.088,5.487.262a48.024,48.024,0,0,1,9.183,1.523V4.233c-.858-.677-3.635-2.478-9.381-2.977"
        fill="#fff"
      />
      <path
        d="M10.419,0C4.649,0,2.582,1.906,2.582,1.906V28.714a19.023,19.023,0,0,1,5.038-.443c1.431,0,3.21.068,5.388.258,6.3.547,9.255,1.528,10.133,1.873l.017,0a.16.16,0,0,0,.158.018c.808-.324,3.75-1.335,10.186-1.894,2.179-.19,3.957-.258,5.388-.258a19.023,19.023,0,0,1,5.038.443V1.906S41.911,0,36.141,0h-.064c-.788,0-1.645.035-2.575.116-6.616.575-9.538,2.8-10.247,3.432C22.546,2.915,19.625.682,13.008.116,12.08.037,11.24.012,10.434,0ZM22.29,28.912a48.19,48.19,0,0,0-9.183-1.523c-2-.173-3.844-.261-5.487-.261a30.808,30.808,0,0,0-3.894.211V2.5c.769-.451,2.788-1.357,6.7-1.357h.008c.787,0,1.624.038,2.479.112,5.746.5,8.523,2.3,9.381,2.977Zm20.5-1.582a30.771,30.771,0,0,0-3.9-.212c-1.642,0-3.488.088-5.486.262A48.02,48.02,0,0,0,24.226,28.9V4.222c.858-.678,3.631-2.476,9.382-2.976.855-.074,1.688-.112,2.475-.112H36.1c3.869,0,5.905.908,6.692,1.364Z"
        fill="#313a38"
      />
      <path
        d="M20.245,9.294A29.892,29.892,0,0,0,6.592,7.623V5.3A29.879,29.879,0,0,1,20.245,6.976Z"
        fill="#3ec7b3"
      />
      <path
        d="M20.245,14.446A29.892,29.892,0,0,0,6.592,12.775V10.456a29.879,29.879,0,0,1,13.653,1.672Z"
        fill="#3ec7b3"
      />
      <path
        d="M20.245,19.6A29.892,29.892,0,0,0,6.592,17.928V15.609a29.879,29.879,0,0,1,13.653,1.672Z"
        fill="#3ec7b3"
      />
      <path
        d="M26.685,9.294A29.892,29.892,0,0,1,40.338,7.623V5.3A29.879,29.879,0,0,0,26.685,6.976Z"
        fill="#3ec7b3"
      />
      <path
        d="M26.685,14.446a29.892,29.892,0,0,1,13.653-1.671V10.456a29.879,29.879,0,0,0-13.653,1.672Z"
        fill="#3ec7b3"
      />
      <path
        d="M26.685,19.6a29.892,29.892,0,0,1,13.653-1.671V15.609a29.879,29.879,0,0,0-13.653,1.672Z"
        fill="#3ec7b3"
      />
      <path
        d="M34.9,31.142l4.278,3.009a.708.708,0,0,1,.178.18.67.67,0,0,1,.062.111.618.618,0,0,1,.042.121l1.152,4.632,7.8-1.94-.887-3.569a.694.694,0,0,1-.021-.17L47.49,23.9l-.43-1.732A.9.9,0,0,0,47,22.007c-.007-.016-.017-.031-.025-.046a.869.869,0,0,0-.057-.094c-.012-.017-.025-.032-.038-.048a.794.794,0,0,0-.068-.074c-.015-.015-.03-.028-.045-.042a.957.957,0,0,0-.082-.06.5.5,0,0,0-.049-.031.766.766,0,0,0-.1-.05c-.013-.006-.026-.013-.039-.018a.9.9,0,0,0-.155-.04c-.011,0-.022,0-.033,0a.981.981,0,0,0-.109-.009l-.016,0a.871.871,0,0,0-.366.085.872.872,0,0,0-.484.628.844.844,0,0,0,.006.386.716.716,0,0,1,.021.143.716.716,0,0,1-.184.508.713.713,0,0,1-.358.215.736.736,0,0,1-.16.019.644.644,0,0,1-.1-.005.24.24,0,0,1-.028,0,.675.675,0,0,1-.125-.032l-.031-.014a.809.809,0,0,1-.084-.04l-.039-.025a.626.626,0,0,1-.066-.049l-.037-.033c-.019-.019-.037-.039-.055-.06l-.03-.039a.639.639,0,0,1-.046-.076c-.007-.012-.014-.024-.02-.037a.686.686,0,0,1-.046-.127l-.394-1.585a.927.927,0,0,0-.057-.158c-.007-.016-.017-.031-.025-.046a.978.978,0,0,0-.057-.094c-.012-.017-.025-.032-.038-.048a.8.8,0,0,0-.068-.074c-.015-.014-.029-.028-.045-.041a.831.831,0,0,0-.082-.061c-.016-.01-.032-.022-.048-.031a.994.994,0,0,0-.1-.05c-.013,0-.026-.013-.04-.018a1.025,1.025,0,0,0-.154-.04l-.034,0a.788.788,0,0,0-.108-.01l-.016,0a.9.9,0,0,0-.2.025.883.883,0,0,0-.619.557.872.872,0,0,0-.027.517.715.715,0,0,1-.522.866.73.73,0,0,1-.16.02.809.809,0,0,1-.1-.006l-.028,0a.667.667,0,0,1-.124-.033l-.031-.013a.665.665,0,0,1-.085-.041l-.039-.025a.627.627,0,0,1-.066-.049l-.036-.033a.621.621,0,0,1-.055-.06.368.368,0,0,1-.03-.039.813.813,0,0,1-.047-.076c-.006-.012-.014-.024-.02-.037a.767.767,0,0,1-.046-.127l-.394-1.585A.837.837,0,0,0,40,20.384c-.008-.017-.017-.031-.026-.047a.692.692,0,0,0-.057-.094c-.012-.017-.024-.032-.037-.048a.962.962,0,0,0-.068-.074c-.015-.014-.03-.028-.046-.041a.953.953,0,0,0-.081-.061c-.016-.01-.032-.022-.049-.031a.906.906,0,0,0-.1-.05c-.013,0-.026-.013-.04-.017a.811.811,0,0,0-.154-.04c-.011,0-.022,0-.033,0a.788.788,0,0,0-.109-.009l-.016,0a.836.836,0,0,0-.2.024h0a.874.874,0,0,0-.487.325.887.887,0,0,0-.185.572.912.912,0,0,0,.026.177.728.728,0,0,1-.022.417.735.735,0,0,1-.141.234.717.717,0,0,1-.358.215.746.746,0,0,1-.161.02.822.822,0,0,1-.1-.006l-.028,0a.667.667,0,0,1-.124-.033.287.287,0,0,1-.031-.013.665.665,0,0,1-.085-.041.425.425,0,0,1-.039-.025.626.626,0,0,1-.066-.049c-.012-.01-.024-.022-.036-.033a.621.621,0,0,1-.055-.06c-.01-.013-.021-.025-.03-.038a.731.731,0,0,1-.046-.076c-.007-.013-.015-.025-.021-.038a.733.733,0,0,1-.045-.127l-2.157-8.67h0a.914.914,0,0,0-.056-.157c-.008-.016-.017-.031-.026-.047a.759.759,0,0,0-.057-.094.545.545,0,0,0-.037-.047.962.962,0,0,0-.068-.074.6.6,0,0,0-.046-.042.941.941,0,0,0-.081-.06c-.016-.011-.032-.022-.049-.032a.761.761,0,0,0-.1-.049c-.013-.006-.026-.013-.04-.018a.893.893,0,0,0-.154-.04c-.011,0-.022,0-.033,0a.981.981,0,0,0-.109-.009l-.016,0a.892.892,0,0,0-.2.024h0a.883.883,0,0,0-.545.4.859.859,0,0,0-.073.153.881.881,0,0,0-.028.517l3.406,13.7a.7.7,0,0,1,.02.135.713.713,0,0,1-.483.714.65.65,0,0,1-.127.03.3.3,0,0,1-.042,0,.678.678,0,0,1-.078,0,.74.74,0,0,1-.176-.025l-.035-.012a.776.776,0,0,1-.146-.068l-.021-.012a.684.684,0,0,1-.134-.118l-.027-.032a.766.766,0,0,1-.1-.16L33.8,24.191a.839.839,0,0,0-.079-.141c-.008-.013-.018-.025-.027-.038a1.078,1.078,0,0,0-.077-.088c-.01-.011-.02-.021-.031-.031a.836.836,0,0,0-.121-.094l-.011-.006a.867.867,0,0,0-.125-.064l-.043-.016a.858.858,0,0,0-.11-.031c-.014,0-.028-.007-.042-.009a.8.8,0,0,0-.147-.014h-.005a.928.928,0,0,0-.116.011c-.02,0-.039,0-.059.007a.829.829,0,0,0-.173.055A.887.887,0,0,0,32.18,24.9Z"
        fill="#fff"
      />
      <path
        d="M41.932,18.487a3.261,3.261,0,0,0-.4.126,3.169,3.169,0,0,0-3.106-.938l-.028.007-1.39-5.591a3.173,3.173,0,0,0-6.159,1.532l1.928,7.755a3.129,3.129,0,0,0-1.059.259,3.176,3.176,0,0,0-1.638,4.177l2.078,4.762H33.1l-2.228-5.1a2.3,2.3,0,0,1-.18-.672,2.14,2.14,0,0,1-.013-.226,2.316,2.316,0,0,1,.16-.874c.027-.069.058-.136.091-.2a2.378,2.378,0,0,1,.186-.3,2.229,2.229,0,0,1,.2-.246,2.265,2.265,0,0,1,.469-.376c.057-.036.117-.068.178-.1.035-.018.069-.037.106-.053h0a2.216,2.216,0,0,1,.226-.085c.027-.009.054-.014.081-.021.051-.014.1-.029.153-.04.032-.006.063-.009.1-.014s.094-.016.14-.021.067,0,.1,0,.082-.006.122-.006H33c.046,0,.091,0,.136.008s.069,0,.1.006.094.014.14.022.064.009.1.016c.05.011.1.025.148.039l.081.022c.071.023.141.05.21.08l.012,0-2.241-9.011a2.314,2.314,0,0,1,.072-1.351,2.351,2.351,0,0,1,.456-.759c.05-.055.1-.108.158-.158a2.292,2.292,0,0,1,.36-.271,2.328,2.328,0,0,1,.642-.267,2.193,2.193,0,0,1,.26-.048c.028,0,.055-.005.082-.008.06-.005.119-.009.177-.01l.04,0c.028,0,.055,0,.082,0s.053,0,.079,0c.05,0,.1.009.149.016l.061.008a2,2,0,0,1,.2.043c.012,0,.023.007.035.01q.083.023.165.051l.066.026c.043.017.085.034.127.054l.071.034c.039.02.077.041.115.063s.046.026.068.04c.039.024.076.049.114.076l.058.041c.045.034.087.069.129.1l.032.027c.052.047.1.1.148.147.013.013.024.028.036.042.034.039.067.078.1.118l.045.062c.026.037.051.074.076.113l.042.07c.023.039.044.078.064.119q.019.036.036.072c.021.045.039.091.057.137.009.022.018.043.026.065.024.069.046.139.064.211l1.64,6.595a2.291,2.291,0,0,1,.817-.386,2.472,2.472,0,0,1,.252-.046l.07-.008c.066-.007.131-.011.2-.012l.041,0h.016a2.233,2.233,0,0,1,.284.02l.057.009a2.344,2.344,0,0,1,.279.06l.023.007a2.466,2.466,0,0,1,.253.093l.047.02a2.282,2.282,0,0,1,.244.13l.048.031a2.212,2.212,0,0,1,.231.166l.01.009a2.267,2.267,0,0,1,.2.192l.037.039a2.175,2.175,0,0,1,.173.22c.011.015.021.031.031.047a2.2,2.2,0,0,1,.148.255,2.3,2.3,0,0,1,.4-.252,2.354,2.354,0,0,1,.46-.167,2.208,2.208,0,0,1,.251-.046l.071-.008q.1-.01.195-.012l.042,0h.016a2.218,2.218,0,0,1,.283.02l.058.009a2.2,2.2,0,0,1,.279.06l.022.007a2.4,2.4,0,0,1,.254.093l.046.02a2.3,2.3,0,0,1,.245.13l.048.031a2.2,2.2,0,0,1,.23.166l.011.01a2.249,2.249,0,0,1,.2.191l.036.039a2.335,2.335,0,0,1,.174.22V19.033a3.152,3.152,0,0,0-2.668-.546"
        fill="#fff"
      />
      <path
        d="M49.979,37.6,48.94,33.426l-.021-9.619a.708.708,0,0,0-.021-.171l-.452-1.816a2.062,2.062,0,0,0-.064-.211c-.007-.023-.017-.044-.025-.066-.018-.046-.037-.091-.057-.136-.011-.024-.024-.048-.036-.072-.02-.041-.042-.081-.064-.12l-.042-.069c-.025-.039-.051-.077-.077-.113s-.029-.042-.044-.062c-.032-.041-.066-.08-.1-.119-.012-.014-.023-.028-.035-.041-.047-.051-.1-.1-.148-.147l-.032-.026c-.042-.037-.085-.073-.129-.106l-.058-.041c-.038-.027-.076-.052-.115-.077l-.066-.039c-.039-.022-.078-.043-.118-.063l-.069-.034c-.042-.02-.085-.037-.128-.054l-.065-.026c-.055-.019-.112-.037-.168-.052l-.032-.01c-.067-.017-.136-.031-.2-.042-.02,0-.04,0-.059-.008-.05-.007-.1-.013-.151-.016l-.077,0h-.123c-.059,0-.118.006-.177.011-.027,0-.055,0-.082.008a2.156,2.156,0,0,0-.26.048,2.229,2.229,0,0,0-.236.072,2.324,2.324,0,0,0-.626.346,2.227,2.227,0,0,0-.148-.255c-.01-.015-.02-.031-.031-.046a2.186,2.186,0,0,0-.173-.221l-.037-.038a2.132,2.132,0,0,0-.2-.192l-.01-.009a2.222,2.222,0,0,0-.231-.167l-.048-.031a2.477,2.477,0,0,0-.244-.13l-.046-.019a2.267,2.267,0,0,0-.254-.093l-.023-.008a2.37,2.37,0,0,0-.278-.06L43,19.273a2.233,2.233,0,0,0-.284-.021l-.057,0c-.065,0-.13.005-.2.012l-.071.007a2.511,2.511,0,0,0-.251.047,2.3,2.3,0,0,0-.861.418h0a2.377,2.377,0,0,0-.147-.255c-.011-.015-.021-.031-.031-.046a2.336,2.336,0,0,0-.174-.22l-.036-.039a2.408,2.408,0,0,0-.2-.192l-.011-.009a2.209,2.209,0,0,0-.23-.167l-.048-.03a2.2,2.2,0,0,0-.245-.13l-.046-.02a2.267,2.267,0,0,0-.254-.093l-.022-.008a2.387,2.387,0,0,0-.279-.06l-.058-.008a2.218,2.218,0,0,0-.283-.021l-.058,0q-.1,0-.195.012c-.024,0-.047,0-.071.008a2.208,2.208,0,0,0-.251.046,2.311,2.311,0,0,0-.818.385L36.179,12.3c-.018-.072-.04-.143-.064-.212-.008-.022-.017-.043-.025-.065-.018-.046-.037-.092-.057-.136L36,11.814c-.02-.041-.042-.081-.064-.12-.014-.023-.028-.047-.043-.07s-.05-.075-.076-.112c-.015-.021-.029-.042-.045-.062-.031-.041-.064-.08-.1-.118l-.036-.043c-.048-.051-.1-.1-.148-.146l-.032-.027q-.063-.055-.129-.105c-.019-.015-.039-.028-.059-.042-.037-.026-.075-.052-.113-.076l-.068-.04c-.038-.022-.077-.042-.116-.062l-.071-.035c-.041-.019-.084-.036-.126-.053l-.067-.026c-.054-.019-.109-.036-.165-.052l-.034-.01c-.067-.017-.136-.031-.205-.043l-.06-.007c-.05-.007-.1-.013-.15-.016l-.078,0c-.041,0-.081,0-.122,0-.059,0-.118.005-.177.011-.028,0-.055,0-.082.008a2.367,2.367,0,0,0-.26.047,2.287,2.287,0,0,0-.642.268,2.234,2.234,0,0,0-.361.27c-.055.051-.107.1-.157.159a2.329,2.329,0,0,0-.456.758,2.366,2.366,0,0,0-.113.434,2.305,2.305,0,0,0,.041.918l2.24,9.01-.012,0a2.194,2.194,0,0,0-.209-.08c-.027-.009-.055-.014-.082-.022-.049-.014-.1-.029-.148-.04-.031-.006-.064-.01-.095-.015-.047-.008-.093-.017-.14-.023s-.069,0-.1-.006-.091-.007-.136-.007-.09,0-.134.006-.067,0-.1,0-.094.013-.14.02-.064.008-.1.015c-.052.01-.1.025-.154.039-.027.008-.054.013-.08.021a2.374,2.374,0,0,0-.226.085l-.005,0c-.036.016-.07.035-.1.052-.062.031-.121.064-.179.1a2.326,2.326,0,0,0-.468.376,2.55,2.55,0,0,0-.385.547,2.168,2.168,0,0,0-.091.2,2.335,2.335,0,0,0-.161.873,2.16,2.16,0,0,0,.014.227,2.343,2.343,0,0,0,.179.672L33.674,31.9a.71.71,0,0,0,.243.3l4.224,2.971,1.26,5.067a.661.661,0,0,0,.046.127c.006.013.014.025.02.038a.73.73,0,0,0,.046.076l.03.038c.018.021.036.041.055.06s.024.023.037.033a.626.626,0,0,0,.066.049.322.322,0,0,0,.039.025.652.652,0,0,0,.084.041l.032.014a.728.728,0,0,0,.124.032l.027,0a.827.827,0,0,0,.1.006.73.73,0,0,0,.16-.02l9.19-2.285a.716.716,0,0,0,.522-.866m-1.56-.349-7.8,1.94-1.152-4.632a.824.824,0,0,0-.042-.121.67.67,0,0,0-.062-.111.725.725,0,0,0-.178-.18L34.9,31.142,32.179,24.9a.888.888,0,0,1,.458-1.167.868.868,0,0,1,.173-.055c.02,0,.04,0,.06-.006a.748.748,0,0,1,.116-.012h0a.916.916,0,0,1,.148.014c.014,0,.027.006.041.009a.993.993,0,0,1,.11.031l.043.016a.828.828,0,0,1,.126.064l.011.006a.836.836,0,0,1,.121.094c.011.01.02.021.031.031a.811.811,0,0,1,.076.089c.01.012.019.024.028.037a.839.839,0,0,1,.079.141l1.325,3.036a.707.707,0,0,0,.1.16.414.414,0,0,0,.027.032.708.708,0,0,0,.133.118l.021.012a.7.7,0,0,0,.147.068.36.36,0,0,0,.035.012.693.693,0,0,0,.176.026.679.679,0,0,0,.078,0c.014,0,.028,0,.041,0a.807.807,0,0,0,.127-.03A.715.715,0,0,0,36.5,26.9a.721.721,0,0,0-.02-.136l-3.406-13.7A.887.887,0,0,1,33.718,12a.846.846,0,0,1,.2-.025l.016,0a.981.981,0,0,1,.109.009c.011,0,.022,0,.033,0a.893.893,0,0,1,.154.04c.014.005.027.012.04.018a.827.827,0,0,1,.1.05c.017.009.032.02.049.031s.055.039.081.06a.6.6,0,0,1,.045.042.678.678,0,0,1,.068.074c.013.016.026.031.038.048a.734.734,0,0,1,.057.094c.008.015.018.03.026.046a.914.914,0,0,1,.056.157h0l2.156,8.67a.661.661,0,0,0,.046.127c.006.013.014.025.02.038a.731.731,0,0,0,.046.076c.01.013.02.026.031.038a.77.77,0,0,0,.054.06.38.38,0,0,0,.037.033.626.626,0,0,0,.066.049c.013.009.025.018.039.026a.81.81,0,0,0,.084.04l.032.014a.728.728,0,0,0,.124.032l.027,0a.663.663,0,0,0,.1.006.674.674,0,0,0,.16-.02.7.7,0,0,0,.359-.215.711.711,0,0,0,.162-.651.9.9,0,0,1-.025-.177.9.9,0,0,1,.672-.9h0a.891.891,0,0,1,.2-.024l.016,0a.788.788,0,0,1,.109.009c.011,0,.022,0,.033,0a.831.831,0,0,1,.154.04l.04.017a1.1,1.1,0,0,1,.1.05c.017.01.032.021.048.032a.689.689,0,0,1,.082.06c.016.013.03.027.045.041a.807.807,0,0,1,.068.075c.013.015.026.031.038.047s.039.062.057.094c.008.016.018.031.025.047a.839.839,0,0,1,.057.157l.394,1.585a.661.661,0,0,0,.046.127c.006.013.013.025.02.038a.731.731,0,0,0,.046.076l.03.038c.018.021.036.041.055.06a.38.38,0,0,0,.037.033.627.627,0,0,0,.066.049.322.322,0,0,0,.039.025.652.652,0,0,0,.084.041l.031.014a.764.764,0,0,0,.125.032l.027,0a.826.826,0,0,0,.1.006.738.738,0,0,0,.16-.02.714.714,0,0,0,.521-.866.888.888,0,0,1,.646-1.074.85.85,0,0,1,.2-.024l.016,0a.788.788,0,0,1,.109.009c.011,0,.022,0,.033,0a.811.811,0,0,1,.154.04l.041.017a.978.978,0,0,1,.1.05c.017.01.033.021.049.032a.769.769,0,0,1,.081.06c.016.013.031.027.046.041s.046.048.068.074a.558.558,0,0,1,.037.048.759.759,0,0,1,.057.094c.009.016.018.03.026.047a.917.917,0,0,1,.057.157l.394,1.585a.733.733,0,0,0,.045.127c.006.013.014.025.021.038a.731.731,0,0,0,.046.076c.009.013.02.025.03.038a.621.621,0,0,0,.055.06l.036.033a.626.626,0,0,0,.066.049c.013.008.026.018.039.025a.538.538,0,0,0,.084.04.222.222,0,0,0,.032.014.667.667,0,0,0,.124.033l.028,0a.822.822,0,0,0,.1.006.747.747,0,0,0,.161-.02.717.717,0,0,0,.358-.215.735.735,0,0,0,.141-.234.728.728,0,0,0,.022-.417.905.905,0,0,1,.2-.808.9.9,0,0,1,.275-.206.94.94,0,0,1,.169-.06.9.9,0,0,1,.2-.025H46.2a.774.774,0,0,1,.108.009l.034,0a.9.9,0,0,1,.154.041.282.282,0,0,1,.04.017.906.906,0,0,1,.1.05c.017.009.032.021.049.031a.953.953,0,0,1,.081.061c.016.013.031.027.046.041a.961.961,0,0,1,.068.074c.012.016.025.031.037.048a.81.81,0,0,1,.057.094.522.522,0,0,1,.026.047.836.836,0,0,1,.056.157L47.49,23.9l.02,9.619a.764.764,0,0,0,.022.171Z"
        fill="#313a38"
      />
    </svg>
  </Wrapper>
)
export default ManualDownloadSvg
